import { defineQuery, useQuery } from "@pinia/colada";

export const useBlog = defineQuery(() => {
  const params = ref<PaginationParams>({ page: 1, per_page: 10 });
  const { data: blog, isLoading, status, error } = useQuery<Blog, Error, Blog>({
    key: () => ["blog", { ...params.value }],
    query: async () => {
      console.log("Querying blog...");
      const response = await ajaxRequest<Blog>("get_blog", params.value);
      console.log(response);
      return v.parse(blogSchema, response);
    },
    placeholderData: { posts: [], posts_total: 0 },
    staleTime: 1000 * 60 * 60 * 24,
  });
  return { params, blog, isLoading, status, error };
});
